import React, { useState } from "react";
import {
  showError,
  showSuccess,
} from "../../../../../../../../utils/showMessage.js";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Images from "../../../../../../../../utils/images.js";
import CrossButton from "../../../../../../../common/ButtonSpinner/CrossButton.js";
import GeneralButton from "../../../../../../../common/SaveButton/GeneralButton.js";
import CustomModal from "../../../../../../../common/CustomModal/CustomModal.js";
import { Tooltip } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";

import { createDatabase } from "../../../../../../../../api/database_gui.js";
import { getDatabaseNameValidationError } from "../../utils/databaseValidation.js";

const DatabaseCreatePopup = ({
  visible,
  onClose,
  onSave,
  formData,
  loading,
  setLoading,
  setFormData,
  appId,
  systemUserId,
  setCreateDatabasePopup,
  databaseInfo,
}) => {
  const [validationError, setValidationError] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;
    setFormData(value);
    
    if (validationError) {
      setValidationError("");
    }
    
    const error = getDatabaseNameValidationError(value);
    setValidationError(error);
  };

  const handleSave = async () => {
    if (!formData.trim()) {
      setValidationError("Database name is required");
      showError("Database name is required");
      return;
    }

    if (formData.includes(" ")) {
      setValidationError("Database name cannot contain spaces");
      showError("Database name cannot contain spaces");
      return;
    }

    if (validationError) {
      showError(validationError);
      return;
    }

    try {
      const response = await createDatabase(appId, systemUserId, formData);

      if (response.error) {
        let errorMessage = null;
        
        if (typeof response.error === 'string') {
          errorMessage = response.error;
        } else if (response.error.message) {
          if (Array.isArray(response.error.message)) {
            errorMessage = response.error.message.join(', ');
          } else {
            errorMessage = response.error.message;
          }
        } else if (Array.isArray(response.error)) {
          errorMessage = response.error.join(', ');
        } else if (typeof response.error === 'object') {
          errorMessage = JSON.stringify(response.error);
        }
        
        if (errorMessage) {
          showError(errorMessage);
        }
      } else {
        setFormData("");
        setValidationError("");
        const successMessage = response.data?.message;
        if (successMessage) {
          showSuccess(successMessage);
        }
        onSave(formData);
        onClose();
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 
                          error?.response?.data?.errors?.message || 
                          error?.message;
      if (errorMessage) {
        showError(Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage);
      }
    }
  };

  const isValid = formData.trim() && !validationError;

  return (
    <CustomModal 
      open={visible} 
      handleClose={onClose}
      width="40%"
    >
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <div className="d-flex align-items-center mb-1">
              {databaseInfo === "MySQL" && (
                <img src={Images.mysql} alt="MySQL" width="24" height="24" className="me-2" />
              )}
              {databaseInfo === "PostgreSQL" && (
                <img src={Images.pssql} alt="PostgreSQL" width="24" height="24" className="me-2" />
              )}
              {databaseInfo === "MSSQL" && (
                <img src={Images.mssql} alt="MSSQL" width="24" height="24" className="me-2" />
              )}
              <h3 className="border-0 customize-column-name mb-0">
                Create New Database
              </h3>
            </div>
            <p className="text-muted mb-0 fs-14px">
              Add a new database to your application for storing and managing data
            </p>
          </div>
          <CrossButton onClick={onClose} />
        </div>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleSave();
          }}
        >
          <div className="mb-4">
            <Form.Label className="input_label d-flex align-items-center mb-2">
              Database Name
              <span className="text-danger ms-1">*</span>
              <Tooltip
                title="Database names must be unique and can contain letters, numbers, underscores, hyphens, and dots. They cannot exceed 64 characters and cannot start/end with numbers, hyphens, or dots."
                placement="top-end"
              >
                <img
                  src={Images.InfoIcon}
                  alt="info"
                  width="15"
                  height="15"
                  className="cursor_pointer ms-2"
                />
              </Tooltip>
            </Form.Label>

            <Form.Control
              className={`form_input_field ${validationError ? 'is-invalid' : ''} ${isValid ? 'is-valid' : ''}`}
              type="text"
              value={formData}
              onChange={handleChange}
              placeholder="Enter Database Name"
              maxLength={64}
            />
            
            {validationError && (
              <div className="invalid-feedback d-block mt-1">
                {validationError}
              </div>
            )}
            
            {isValid && (
              <div className="valid-feedback d-block mt-1">
                Database name looks good!
              </div>
            )}
          </div>

          <Row className="pt-4 mb-3 justify-content-end">
            <Col sm="auto">
              <GeneralButton
                onClickEvent={onClose}
                className="me-1"
                value="Cancel"
                color="#505050"
                variant="outlined"
                size="large"
              />
            </Col>
            <Col sm="auto" className="me-sm-2 p-0">
              {loading ? (
                <GeneralButton
                  onClick={handleSave}
                  variant="contained"
                  disabled={true}
                  className="me-1"
                  value={
                    <img src={Images.Loader} width="26px" height="26px" />
                  }
                  size="large"
                />
              ) : (
                <GeneralButton
                  className="me-1"
                  value="Create"
                  variant="contained"
                  size="large"
                  disabled={!isValid}
                />
              )}
            </Col>
          </Row>
        </Form>
      </div>
    </CustomModal>
  );
};

export default DatabaseCreatePopup;
